import { render } from "./devImportSpecies.vue?vue&type=template&id=54749fb6&scoped=true"
import script from "./devImportSpecies.vue?vue&type=script&lang=js"
export * from "./devImportSpecies.vue?vue&type=script&lang=js"

import "./devImportSpecies.vue?vue&type=style&index=0&id=54749fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54749fb6"]])

export default __exports__